import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconAiRobotColor from './icon-ai-robot-color.vue';

const IconAiRobotColor = Object.assign(_IconAiRobotColor, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconAiRobotColor.name, _IconAiRobotColor);
  }
});

export default IconAiRobotColor;
